export const BASKET_LOCATION = [
    {
        name: 'Tất cả',
        value: 'all',
    },
    {
        name: 'Thường (US)',
        value: 'us',
    },
    {
        name: 'Quốc tế',
        value: 'international',
    },
]

export const BASKET_STATUS = [
    {
        name: 'Tất cả',
        value: 'all',
    },
    {
        name: 'Đang chờ',
        value: 'waiting',
    },
    {
        name: 'Đã hoàn thành',
        value: 'completed',
    },
    {
        name: 'Tự do',
        value: 'free',
    },

]

export const BASKET_TOTAL_ITEMS = [
    {
        name: 'Chưa chọn',
        value: ''
    },
    {
        name: 'Đơn 2',
        value: 2,
    },
    {
        name: 'Đơn 3',
        value: 3,
    },
    {
        name: 'Đơn  4',
        value: 4,
    },
    {
        name: 'Đơn  5',
        value: 5,
    },
]

export const listPartner = [
    {name: 'All', value: ''},
    { value: 'BINHMINH', name: 'Bình Minh' },
    { value: 'QUANGMINH', name: 'Quang Minh' },
    { value: 'TOANCAU', name: 'Toàn Cầu' },
]

export const listBasketType = [
    {name: 'All', value: ''},
    { value: 'normal', name: 'Đơn thường' },
    { value: 'combo_fac', name: 'Combo FAC' },
    { value: 'combine_ship', name: 'Gộp ship' },
]
